import { render } from "./App.vue?vue&type=template&id=ed69b732"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ed69b732&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__